export default "__VITE_ASSET__D0nDbtI9__"